@use '@lib/assets/styles/main.scss' as *;

.previewButtonWrapper {
  display: flex;
  justify-content: flex-end;
}
